import { DatePicker, Input, InputNumber, Modal, Select } from 'antd'
import React, { useCallback } from 'react'
import { Wind2SubgroupHeaders } from './Wind2Subgroup'

const Wind2SubgrouptModal = ({
  // retrieve,
  // validateData,
  setInsertData,
  insertData,
  onAdd,
  onCancel,
  setInsertEvent,
  insertEvent,
  regimeMap = {},
  ownershipStatusMap = {},
  scadaMap = {},
  turbineMap = {},
  turbulenceMap = {},
  shearMap = {},
  turbineTypeMap = {},
  plantMap = {},
  entityMap = {},
}) => {
  const getLabel = useCallback((key, isKey, isRequired) => {
    return (
      <div>
        {isKey && <span style={{ color: 'red', marginRight: '2px' }}>*</span>}
        {!isKey && isRequired && (
          <span style={{ color: 'red', marginRight: '2px' }}>*</span>
        )}
        {Wind2SubgroupHeaders.find(f => f.ident === key).display} :
      </div>
    )
  }, [])

  const getInput = useCallback(
    ({
      key,
      maxLength,
      isKey,
      insertData,
      setInsertData,
      isRequired = false,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Input
          disabled={insertData.insert && isKey}
          data-cy={key}
          value={insertData[key]}
          onChange={e =>
            setInsertData({ ...insertData, [key]: e.target.value })
          }
          maxLength={maxLength}
        />
      </div>
    ),
    [getLabel]
  )

  const getInputNumber = useCallback(
    ({
      key,
      precision = 0,
      isKey = false,
      insertData,
      setInsertData,
      isRequired = false,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <InputNumber
          disabled={insertData.insert && isKey}
          style={{ width: '100%' }}
          data-cy={key}
          value={insertData[key]}
          onChange={value =>
            setInsertData({ ...insertData, [key]: value + '' })
          }
          precision={precision}
        />
      </div>
    ),
    [getLabel]
  )

  const getMapSelect = useCallback(
    ({
      key,
      keymap,
      isKey,
      setInsertData,
      insertData,
      isRequired = false,
      extStyle = {},
    }) => (
      <div style={{ ...extStyle }}>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Select
          disabled={insertData.insert && isKey}
          data-cy={key}
          style={{ width: '100%', zIndex: 1500 }}
          value={insertData[key]}
          onChange={val => setInsertData({ ...insertData, [key]: val })}
        >
          {Object.keys(keymap).map(k => (
            <Select.Option value={k} key={k} data-cy={key}>
              {/* {`${k}-${keymap[k]}`} */}
              {`${keymap[k]}`}
            </Select.Option>
          ))}
        </Select>
      </div>
    ),
    [getLabel]
  )

  const getDate = useCallback(
    ({ key, insertData, isKey, setInsertData, isRequired = false }) => (
      <div>
        {getLabel(key, isKey, isRequired)}
        <DatePicker
          style={{ width: '100%' }}
          data-cy={key}
          format="MM/DD/YYYY"
          value={insertData[key + 'date']}
          onChange={d => {
            setInsertData({
              ...insertData,
              [key]: d.format('YYYY-MM-DD'),
              [key + 'date']: d,
            })
          }}
        />
      </div>
    ),
    [getLabel]
  )

  return (
    <Modal
      centered
      maskClosable={false}
      afterClose={_ => onCancel(false)}
      okText="Save"
      zIndex={500}
      destroyOnClose
      title="Insert data"
      // onOk={_ => insertSaveData({ retrieve, validateData })}
      onOk={_ => onAdd(false)}
      onCancel={_ => setInsertEvent(false)}
      visible={insertEvent}
      bodyStyle={{ width: '85vw', overflowX: 'auto' }}
      width="85vw"
    >
      <div
        style={{
          minHeight: '300px',
          display: 'grid',
          gridTemplateColumns: '200px 230px 230px 230px 230px',
          gridTemplateRows: '60px 60px 60px 60px',
          gridColumnGap: '10px',
          gridRowGap: '7px',
        }}
      >
        {/* {getInput({
          setInsertData,
          insertData,
          key: 'entityId',
          isKey: true,
        })} */}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'entityId',
          isKey: true,
          keymap: entityMap,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'plantId',
          isKey: true,
          keymap: plantMap,
        })}
        {/* {getInput({
          setInsertData,
          insertData,
          key: 'groupIdName',
          isKey: true,
        })} */}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'subgroupId',
          min: 0,
          isKey: true,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'subgroupName',
          isKey: true,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'subgroupOwnershipStatus',
          keymap: ownershipStatusMap,
          isRequired: true,
        })}

        {getInputNumber({
          setInsertData,
          insertData,
          key: 'elevation',
          min: 0,
          isRequired: true,
        })}

        {getInputNumber({
          setInsertData,
          insertData,
          key: 'totalInstalledCap',
          min: 0,
          precision: 3,
          isRequired: true,
        })}

        {getInputNumber({
          setInsertData,
          insertData,
          key: 'numberTurbines',
          min: 0,
          precision: 0,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'trubineSystemMw',
          min: 0,
          precision: 3,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'maxTurbineCapacity',
          min: 0,
          precision: 3,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'annualAvgWindspeed',
          min: 0,
          precision: 2,
          isRequired: true,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'scadaManufacturer',
          keymap: scadaMap,
          isRequired: true,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'scadaModel',
          maxLength: 10,
          isRequired: true,
        })}
        {getDate({
          setInsertData,
          insertData,
          key: 'commissionDate',
          maxLength: 10,
          isRequired: true,
        })}
        {getDate({
          setInsertData,
          insertData,
          key: 'effectiveDate',
          maxLength: 10,
          isKey: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'rotorHeight',
          min: 0,
          precision: 2,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'rotorDiameter',
          min: 0,
          precision: 2,
          isRequired: true,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'windRegime',
          keymap: regimeMap,
          isKey: true,
        })}

        {/* <div style={{ gridColumnEnd: 'span 1' }} /> */}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'trubineManufacturer',
          keymap: turbineMap,
          isRequired: true,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'trubineModel',
          maxLength: 20,
          isRequired: true,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'trubineModelVersion',
          maxLength: 20,
          isRequired: true,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'trubineType',
          maxLength: 20,
          keymap: turbineTypeMap,
          extStyle: { gridColumnEnd: 'span 3' },
          isRequired: true,
        })}

        {getInputNumber({
          setInsertData,
          insertData,
          key: 'cutInWindspeed',
          min: 0,
          precision: 2,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'lowCutOutWindspeed',
          min: 0,
          precision: 2,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'highCutOutWindspeed',
          min: 0,
          precision: 2,
          isRequired: true,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'turbulenceIntensity',
          keymap: turbulenceMap,
          isRequired: true,
        })}

        {getMapSelect({
          setInsertData,
          insertData,
          key: 'windShearId',
          keymap: shearMap,
          extStyle: { gridColumnEnd: 'span 2' },
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'refAnemometerHeight',
          min: 0,
          precision: 0,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'minOperatingTemp',
          min: 0,
          precision: 0,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'maxOperatingTemp',
          min: 0,
          precision: 0,
          isRequired: true,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'transferToEntity',
          maxLength: 10,
        })}

        <div />
      </div>
    </Modal>
  )
}

export default Wind2SubgrouptModal
